import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
// import OurWork from '../../pages/OurWork/OurWork';
import { AiOutlineWhatsApp } from 'react-icons/ai';
import Routers from './Routers';
// import Login from "../../pages/Login/Login";

// <Route path="/login" exact element={<Login />} />

function Navigation() {
  return (
    <Router>
      <Navbar />
      <div
        title='تواصل معنا الان'
        className='fixed bottom-0 mr-10 mb-10 text-4xl bg-amber rounded-full p-3 cursor-pointer text-green500 hover:bg-green500 hover:text-textBlack z-10'
      >
        <a
          href='https://api.whatsapp.com/send?phone=970566012888'
          target='-blank'
        >
          <AiOutlineWhatsApp />
        </a>
      </div>

      <main>
        <Routers />
      </main>
    </Router>
  );
}

export default Navigation;
